import { render, staticRenderFns } from "./Win_win.vue?vue&type=template&id=0421d620&scoped=true"
import script from "./Win_win.vue?vue&type=script&lang=js"
export * from "./Win_win.vue?vue&type=script&lang=js"
import style0 from "./Win_win.vue?vue&type=style&index=0&id=0421d620&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421d620",
  null
  
)

export default component.exports